import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/users`;

const usersAPI = {
  async getAll() {
    return apiClient(`${BASE}/`);
  },

  async getOptions() {
    const users = await this.getAll();
    return users.map(u => ({ id: u.id, label: u.full_name, value: u.id }));
  },

  async getById(userId) {
    const users = await this.getAll();
    return users.find(u => u.id === userId);
  }
};

export default usersAPI;
